import Catalog from "./Catalog";

export default function Products() {
  return <Catalog initialTab="products" />;
}
